import { Fragment } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import LineThumbsUpIcon from 'LuxKit/Icons/line/LineThumbsUpIcon'
import { excludeNullOrUndefined } from 'checkout/utils'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'

const Container = styled.div`
  padding: ${rem(12)};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
`

const RecommendationWrapper = styled(Group)`
  display: flex;
  align-items: center;
  gap: ${rem(4)};
`

const Separator = styled.span`
  margin: 0 ${rem(4)};
`

interface Props {
  recommendedForText: string
  rooms: Array<{
    name: string
    bedConfiguration: string | undefined
    size?: string
  }>
}

function RoomBreakdownDetails({
  recommendedForText,
  rooms,
}: Props) {
  const intl = useIntl()
  return (
    <Container>
      <Group direction="vertical" gap={8}>
        <RecommendationWrapper direction="horizontal" gap={4}>
          <Group horizontalAlign="center" verticalAlign="center" direction="horizontal">
            <LineThumbsUpIcon size={16} colour="highlight-secondary" />
          </Group>

          <BodyText variant="small" weight="bold" colour="highlight-secondary">
            {recommendedForText}
          </BodyText>
        </RecommendationWrapper>
        {rooms.map((room, roomIndex) => {
          const configItems = [room.bedConfiguration, room.size].filter(excludeNullOrUndefined)

          return (
            <Group key={roomIndex} direction="vertical" gap={2}>
              <BodyText variant="small" weight="bold" colour="neutral-one">
                {room.name}
              </BodyText>
              <BodyText variant="small" colour="neutral-two">
                {configItems.map((item, index) => (
                  <Fragment key={index}>
                    {index > 0 && <Separator>{intl.formatMessage(middleDotSeparatorMessage)}</Separator>}
                    {item}
                  </Fragment>
                ))}
              </BodyText>
            </Group>
          )
        })}
      </Group>
    </Container>
  )
}

export default RoomBreakdownDetails
